<script>
	import Cabecera from './componentes/cabecera.svelte';
    import Fondo from './componentes/fondo.svelte';
	import Router from 'svelte-spa-router';
	import Inicio from './paginas/index.svelte';
	import Menu from './componentes/menu.svelte';
	import SobreNosotros from './paginas/sobreNosotros.svelte';
	import Tienda from './paginas/tienda.svelte';
	import Faq from './paginas/faq.svelte';
	import Contacto from './paginas/contacto.svelte';

	let routes = {
		'/': Inicio,
		'/sobre-nosotros': SobreNosotros,
		'/tienda':Tienda,
		'/faq':Faq,
		'/contacto':Contacto
	}
</script>
<div class="cuerpo">
    <Cabecera />
    	<div class="contenido">
			<Router routes={routes} />
			<Menu />
		</div>
    <Fondo />
</div>

<style>

	:global(:root){
		--acento2: #883677;
		--acento: #29339B;
		--negro: #030301;
		--principal: #F56476;
		--pastel: #FDD8DD;
	}
	.cuerpo{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
    }
    .contenido{
        background: var(--pastel);
        width: 80vw;
        height: 60vh;
    }

</style>